function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-215.000000, -769.000000)",
  stroke: "white"
}, React.createElement("path", {
  d: "M341.868742,1012.11714 L344.883562,941.49964 L336.969659,941.49964 C335.839101,970.988266 332.447429,974.092332 314.358508,974.092332 L241.249119,974.092332 L305.6909,903.862841 C332.447429,874.762224 344.883562,858.077869 344.883562,829.753268 C344.883562,794.444519 314.358508,770 281.572338,770 C246.525054,770 219.768525,790.952445 219.768525,826.649202 C219.768525,834.409367 225.04446,860.405919 246.901907,860.405919 C256.32322,860.405919 267.251943,853.809779 267.251943,837.513433 C267.251943,822.76912 255.569515,816.948997 250.293579,816.948997 C237.480594,816.948997 237.857446,820.829079 235.219479,820.829079 C231.450953,820.829079 230.320396,818.113021 230.320396,813.844931 C230.320396,806.472774 239.741709,784.356305 263.483418,784.356305 C289.486241,784.356305 297.400144,811.128873 297.400144,833.245342 C297.400144,874.374215 286.848274,910.458981 216,991.940711 L216,1012.11714 L341.868742,1012.11714 Z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-v-59251244": "",
    width: "131px",
    height: "244px",
    viewBox: "0 0 131 244",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "number-2 number"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/2.f6249d1b.svg";
export { SvgComponent as ReactComponent };